import { useState, useEffect } from 'react';
import { showModal, hideModal } from '@aarhus-university/au-designsystem-delphinus/source/js/components/modal-view';

const useModal = (domId, initialState, showCondition = true, hideCondition = false) => {
  const [modal, setModal] = useState({ modal: initialState, sender: null });

  useEffect(() => {
    if (modal.modal && modal.sender && showCondition) {
      showModal(domId, modal.sender, () => {
        setModal({ modal: false, sender: null });
      });
    }

    if (modal.modal && modal.sender && hideCondition) {
      hideModal(domId, modal.sender, () => {
        setModal({ modal: false, sender: null });
      });
    }
  });

  return [modal, setModal];
};

export {
  useModal,
};